import "./DreamGarden.css";
import { useNavigate } from "react-router-dom";
import bgImage from "./images/GarvanaHome9.png";

export default function DreamGarden() {
  const navigate = useNavigate();

  return (
    <section className="dream" onClick={() => navigate("/contact")}>
      <div
        className="dream__bg"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div className="dream__overlay" />
      <div className="dream__content">
        <span className="dream__label">Begin Your Journey</span>
        <h2 className="dream__title">
          We Transform Your Dream Garden<br />
          <em>Into Reality</em>
        </h2>
        <p className="dream__subtitle">
          Every extraordinary outdoor space starts with a single conversation.
        </p>
        <div className="dream__btn">Request a Free Consultation</div>
      </div>
    </section>
  );
}
